<script lang="ts">
import Checkbox from '../Checkbox/Checkbox.vue';

type Props = {
  active?: boolean;
  disabled?: boolean;
};
</script>
<script setup lang="ts">
const emit = defineEmits(['change']);

defineProps<Props>();
</script>

<template>
  <label :class="[$style.item, disabled && $style.itemDisabled]">
    <Checkbox :checked="active" :disabled="disabled" @change="(active) => emit('change', active)" />
    <slot />
  </label>
</template>

<style module lang="scss">
@forward './PanelGroupCheckbox';
</style>
